<template>
  <b-form @submit.prevent="submit" class="flex-center">
    <AuthWrapper
      :label="label"
      :leftIcon="leftIcon"
      :leftIconTooltip="$lang.problem_login_link_caption"
      @handleLeftIcon="goToContactUs"
      rightIcon="arrow-right"
      @handleRightIcon="goBack"
    >
      <template #alertBox><slot name="alertBox" /></template>
      <template #main>
        <b-row>
          <b-col cols="12" md="12">
            <Input
              :title="$lang.enter_mobile"
              :label="$lang.mobile"
              :placeholder="$lang.mobile"
              :value="form.mobile"
              name="mobile"
              id="mobile"
              type="text"
              :minLength="lengthNumber11"
              :maxLength="lengthNumber11"
              :vuelidateObj="$v.form.mobile"
              @input="input"
              @focus="resetValidation"
              @blur="checkValidation"
            />
          </b-col>
          <b-col cols="12" md="12">
            <Captcha
              :value="form.captcha"
              id="captcha"
              name="captcha"
              :minLength="captchaLength"
              :maxLength="captchaLength"
              :vuelidateObj="$v.form.captcha"
              @input="input"
              @getKey="updateCaptchaKey"
              @setShowCaptcha="setShowCaptcha"
              @focus="resetValidation"
              @blur="checkValidation"
            />
          </b-col>
        </b-row>
      </template>
      <template #button>
        <b-row>
          <b-col
            v-if="isLoginWithUsername"
            cols="8"
            sm="7"
            md="6"
            class="padding-left-4"
          >
            <Button
              class="width-percent-100"
              contentClass="justify-content-center"
              variant="outline-primary"
              :text="$lang.loginWithUsername"
              @click="goToAuth()"
            />
          </b-col>
          <b-col
            :cols="isLoginWithUsername ? 4 : 12"
            :sm="isLoginWithUsername ? 5 : 12"
            :md="isLoginWithUsername ? 6 : 12"
            class="padding-right-4"
          >
            <Button
              class="w-100"
              contentClass="justify-content-center"
              variant="primary"
              :text="$lang.continue"
              :loading="loading"
              type="submit"
              @click="submit"
            />
          </b-col>
        </b-row>
      </template>
    </AuthWrapper>
  </b-form>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { AuthWrapper } from "@/components/re-design";
import { Input, Captcha, Button } from "@/components/re-design/forms";
import {
  required,
  requiredIf,
  numeric,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import {
  generateApiUrl,
  checkPersianCharValidation,
  goToRoute,
} from "@/shared/utils";

export default {
  inject: ["goToContactUs", "submitSendCode"],
  mixins: [inputMixin],
  components: {
    AuthWrapper,
    Input,
    Captcha,
    Button,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    leftIcon: {
      type: String,
      default: "help-circle-outline",
    },
    isLoginWithUsername: {
      type: Boolean,
      default: true,
    },
  },
  validations() {
    return {
      form: {
        mobile: {
          required,
          numeric,
          persianCharacters: (val) => !checkPersianCharValidation(val),
          minLength: minLength(this.lengthNumber11),
          maxLength: maxLength(this.lengthNumber11),
        },
        captcha: {
          required: requiredIf(() => this.showCaptcha),
          minLength: minLength(this.captchaLength),
          maxLength: maxLength(this.captchaLength),
        },
      },
    };
  },
  data() {
    return {
      form: {
        mobile: null,
        captcha: null,
        captchaKey: null,
      },
      loading: false,
      state: "SEND_CODE",
    };
  },
  methods: {
    pathOr,
    generateApiUrl,
    checkPersianCharValidation,
    goToRoute,
    goBack() {
      this.$emit("goBack");
    },
    goToAuth() {
      goToRoute("auth", {}, {}, false);
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$anyError || this.loading) return;

      try {
        this.loading = true;
        const mobile = this.form.mobile;
        const captcha = this.form.captcha;
        const key = this.form.captchaKey;
        await this.submitSendCode(mobile, captcha, key);
      } catch (error) {
        this.$generateError(error);
        storeDispatcher("shouldRefreshCaptcha", true);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
